import React, { useContext } from "react";
import { UserContext } from "../../../contexts/CurrentUserContext";
import AgreementsRegistry from "../../ProjectsV2/AgreementsRegistry/AgreementsRegistry";

function AgreementApprovalList({ onChanged }) {
  const { userData } = useContext(UserContext);

  if (!userData?.id) return null;

  return (
    <AgreementsRegistry
      approverId={userData.id}
      embedded
      onChanged={onChanged}
    />
  );
}

export default AgreementApprovalList;
